module.exports = __webpack_public_path__ + "img/google.387f8c51.svg";